import { Dialog } from '@mui/material';
import React from 'react';
import DeAllocateForm from './DeAllocateForm';

const DeAllocateModal = ({
  isOpen,
  toggle,
  deAllocateData,
  getData,
  setSnackBarOpen,
  setSnackBarMessage,
  setSnackbarSeverity,
  setCheckedUsers,
  setDeallocateUsers
}) => {
  return (
    <Dialog
      open={isOpen}
      keepMounted
      maxWidth="sm"
      fullWidth
      scroll="paper"
      onClose={toggle}
    >
      <DeAllocateForm
        deAllocateData={deAllocateData}
        toggle={toggle}
        getData={getData}
        setSnackBarOpen={setSnackBarOpen}
        setSnackBarMessage={setSnackBarMessage}
        setSnackbarSeverity={setSnackbarSeverity}
        setCheckedUsers={setCheckedUsers}
        setDeallocateUsers={setDeallocateUsers}
      />
    </Dialog>
  );
};

export default DeAllocateModal;
